// Pluralizes a regular plural - provide singular string and count
export const pluralize = (singular, count) => {
  if (count === 1) {
    return singular;
  }
  return `${singular}s`;
};
